export default function validate(values = {}, props) {
    const { messages } = props
    const errors = {}
    const maxLengths = {
        personTitle: 10,
        firstName: 100,
        lastName: 100,
    }

    if (!values.personTitle || !values.personTitle.trim() || values.personTitle === 'emptyLabel') {
        errors.personTitle = messages.errors.required({ field: messages.events.personTitle() })
    } else if (values.personTitle.length > maxLengths.personTitle) {
        errors.personTitle = messages.errors.maxLength({ characters: maxLengths.personTitle })
    }

    if (!values.firstName || !values.firstName.trim()) {
        errors.firstName = messages.errors.required({ field: messages.events.firstName() })
    } else if (values.firstName.length > maxLengths.firstName) {
        errors.firstName = messages.errors.maxLength({ characters: maxLengths.firstName })
    }

    if (!values.lastName || !values.lastName.trim()) {
        errors.lastName = messages.errors.required({ field: messages.events.lastName() })
    } else if (values.lastName.length > maxLengths.lastName) {
        errors.lastName = messages.errors.maxLength({ characters: maxLengths.lastName })
    }

    if (!values.logonId || !values.logonId.trim()) {
        errors.logonId = messages.errors.required({ field: messages.events.logonId() })
    } else if (!values.logonId.includes('@') || !values.logonId.includes('.')) {
        errors.logonId = messages.errors.invalid({ field: messages.events.logonId() })
    }

    return errors
}
